<template>
  <div class="mainPage">
    <!-- 轮播图 -->
    <div class="carousel">
      <el-carousel :interval="5000" arrow="always">
        <el-carousel-item v-for="(item,index) in slidelist" :key="index">
          <img :src="item.filepath" alt="" />
          <div class="text">
            <div class="title">{{item.title}}</div>
            <div class="content">{{item.desc}}</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

      <!-- 华特简介 -->
      <div class="product">
          <div class="proTop">
              <div class="title">华特简介</div>
              <div class="subtitle">HTINFOR ABOUT</div>
              <div class="line"></div>
          </div>
          <el-row :gutter="10" style="margin-top: 5rem;">
              <el-col :xs="0" :sm="6" :md="4" :lg="3" :xl="2"><div style="min-height: 1px;"></div></el-col>
              <el-col :xs="24" :sm="6" :md="8" :lg="9" :xl="10">
                  <div class="abt-video"><video :src="info.desc" preload="auto" controls="controls"></video></div>
              </el-col>
              <el-col :xs="{div:24,offset:0}" :sm="6" :md="8" :lg="9" :xl="10">
                  <div class="abt-conjs" v-html="info.content"></div>
              </el-col>
              <el-col :xs="1" :sm="6" :md="4" :lg="3" :xl="2"><div style="min-height: 1px;"></div></el-col>
          </el-row>
      </div>

    <!-- product介绍 -->
    <div class="product">
      <div class="proTop">
        <div class="title">产品与服务</div>
        <div class="subtitle">PRODUCT & SERVICES</div>
        <div class="line"></div>
      </div>
      <div class="proBottom">
        <div class="proItem">
          <img src="../assets/images/home/icon01.svg" alt="" />
          <div class="name">物联网</div>
          <div class="link">边缘网关</div>
          <div class="link">物联网平台</div>
          <div class="link">应用平台</div>
        </div>
        <div class="proItem">
          <img src="../assets/images/home/icon03.svg" alt="" />
          <div class="name">大数据</div>
          <div class="link">大数据平台</div>
          <div class="link">数据可视化</div>
          <div class="link">数据应用</div>
        </div>
        <div class="proItem">
          <img src="../assets/images/home/icon02.svg" alt="" />
          <div class="name">解决方案</div>
          <div class="link">医疗行业</div>
          <div class="link">楼宇智能化</div>
          <div class="link">后勤运维</div>
        </div>
        <div class="proItem">
          <img src="../assets/images/home/icon04.svg" alt="" />
          <div class="name">应用融合</div>
          <div class="link">咨询设计</div>
          <div class="link">应用开发</div>
          <div class="link">智能运维</div>
        </div>
      </div>
    </div>

    <!-- banner图 -->
    <div class="banner2">
      <img src="../assets/images/home/banner05.png" alt="" />
      <div class="nums">
        <div class="numItem">
          <div class="title">75%</div>
          <div class="subtitle">降低风险</div>
          <div class="content">
            前期对产品功能定义及目标用户群调研，上线后进行用户可用性测试。
          </div>
        </div>
        <div class="numItem">
          <div class="title">50%</div>
          <div class="subtitle">战略伙伴</div>
          <div class="content">
            合作的客户中，50%以上的客户都签订了长期战略合作协议。
          </div>
        </div>
        <div class="numItem">
          <div class="title">80+</div>
          <div class="subtitle">经典案例</div>
          <div class="content">
            凭借对服务品质和商业价值的追求，赢得了众多国内外客户的信任。
          </div>
        </div>
      </div>
    </div>

    <!-- 卡片轮播图 -->
    <div class="imgTextCarousel">
      <div class="top">
        <div class="title">案例展示</div>
        <div class="subtitle">CASES</div>
        <div class="line"></div>
      </div>
        <div class="imgBoxList1">
            <div class="imgBox" v-for="(item,index) in caselist" :key="index" @click="gotoDetail(item.id)">
                <div class="img">
                    <img :src="item.thumb" alt="" />
                </div>
                <div class="card">
                    <div class="textTop">{{item.title}}</div>
                    <div class="textBottom">Warehouse Storage</div>
                    <i class="el-icon-right arrow-right"></i>
                </div>
            </div>
        </div>
      <div class="imgBoxList">
        <div class="box1" :style="{ left: boxLeft1 + 'rem' }">
          <div class="imgBox" @mouseenter="clearInterval" @mouseleave="runInterval" v-for="(item,index) in caselist" :key="index" @click="gotoDetail(item.id)">
            <div class="img">
              <img :src="item.thumb" alt="" />
            </div>
            <div class="card">
              <div class="textTop">{{item.title}}</div>
              <div class="textBottom">Warehouse Storage</div>
              <i class="el-icon-right arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="btns">
        <ul>
          <li :class="['btn1', btnActive == 1 ? 'activeBtn' : '']" @click="chooseBtn(1)"></li>
          <li :class="['btn2', btnActive == 2 ? 'activeBtn' : '']" @click="chooseBtn(2)"></li>
          <li :class="['btn3', btnActive == 3 ? 'activeBtn' : '']" @click="chooseBtn(3)"></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "first",
      boxLeft1: 0,
      interval: "",
      btnActive: 1,
      headerActive: 1,
      slidelist: [],
      caselist: [],
      info: [],
    };
  },
    created() {
        this.getslidelist();
        this.getcaselist();
        this.getpagesshow();
    },
  mounted() {
    setTimeout(() => {
      this.move();
    }, 1500);
    this.interval = setInterval(() => {
      this.move();
    }, 3500);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
      getpagesshow() {
          let self = this;
          var url = "index/pages_show?pages_id=5";
          self.$axios.get(self.api.apiurl + url).then(function (res) {
              self.info = res.data.data.info;
          })
      },
      getslidelist() {
          let self = this;
          var url = "index/slide_list";
          self.$axios.get(self.api.apiurl + url).then(function (res) {
              self.slidelist = res.data.data.list;
          })
      },
      getcaselist() {
          let self = this;
          var url = "index/article_list?cate_id=2";
          self.$axios.get(self.api.apiurl + url).then(function (res) {
              self.caselist = res.data.data.list;
          })
      },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    move() {
      this.boxLeft1 = this.boxLeft1 - 50.5;
      if (this.boxLeft1 <= -263) {
        this.boxLeft1 = 0;
      }
      if (this.boxLeft1 <= 0 && this.boxLeft1 > -102) {
        this.btnActive = 1;
      }
      if (this.boxLeft1 <= -102 && this.boxLeft1 > -204) {
        this.btnActive = 2;
      } else if (this.boxLeft1 <= -204) {
        this.btnActive = 3;
      }
    },
    clearInterval() {
      clearInterval(this.interval);
    },
    runInterval() {
      this.interval = setInterval(() => {
        this.move();
      }, 3500);
    },
    chooseBtn(val) {
      this.btnActive = val;
      if (val == 1) {
        this.boxLeft1 = 0;
      } else if (val == 2) {
        this.boxLeft1 = -102;
      } else if (val == 3) {
        this.boxLeft1 = -204;
      }
    },
    gotoDetail(val) {
      this.$router.push(`/productCenter/detail/${val}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.mainPage {
  margin: 0;
  padding: 0;

  .carousel {
    .text {
      position: absolute;
      left: 10rem;
      top: 10rem;
      z-index: 99;
      width: 58rem;
      background-color: rgba(122, 123, 124, 0.5);
      border-radius: 1rem;
      padding: 2.5rem 3rem;
      text-align: left;

      .title {
        font-size: 3.2rem;
        font-weight: 200;
        color: #fff;
        margin-bottom: 1.5rem;
      }

      .content {
        font-size: 1.8rem;
        font-weight: 200;
        color: #fff;
      }
    }
  }

  .tabs {
    width: 192rem;
    height: 60rem;

    .container {
      width: 128rem;
      margin: 0 auto;

      .tabLeft {
        float: left;
        width: 70rem;
        padding-top: 8rem;

        .title {
          font-size: 3.2rem;
          font-weight: 200;
          text-align: left;
          padding-bottom: 3rem;
        }

        .tabItem {
          .titleItem {
            font-size: 2.4rem;
            text-align: left;
            margin-top: 3rem;
          }

          .content {
            font-size: 1.4rem;
            text-align: left;
            margin-top: 1rem;
          }
        }
      }

      .tabRight {
        display: inline-block;
        width: 58rem;
        padding-top: 5rem;

        img {
          width: 50rem;
          height: 50rem;
        }
      }
    }
  }

  .product {
    width: 100%;

    .proTop {
      width: 100%;
      text-align: center;
      margin-top: 6rem;

      .title {
        color: #2e7de8;
        font-size: 4.6rem;
      }

      .subtitle {
        font-size: 3rem;
        color: #c0c0c0;
        padding: 1rem 0 1.5rem 0;
      }

      .line {
        margin: 0 auto;
        width: 16rem;
        background-color: #2e7de8;
        height: 0.4rem;
      }
    }

    .proBottom {
      width: 60%;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 8rem 0 10rem 0;

      .proItem {
        img {
          width: 8rem;
          height: 8rem;
          margin-bottom: 3rem;
        }

        .name {
          color: black;
          font-size: 2rem;
          font-weight: 600;
          padding: 0 0 1.5rem 0.5rem;
        }

        .link {
          font-size: 1.6rem;
          color: #1d1d1d;
          padding: 0.6rem 0 0 0.5rem;
        }
      }
    }
  }

  .banner2 {
    position: relative;
    width: 100%;

    img {
      width: 100%;
    }

    .nums {
      position: absolute;
      left: 0;
      top: 0;
      color: #fff;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 10rem 0;
      padding-left: 15rem;

      .numItem {
        width: 34rem;
        text-align: center;
        padding: 5rem 10rem;

        .title {
          font-size: 4.6rem;
          font-weight: 300;
        }

        .subtitle {
          font-size: 3rem;
          font-weight: 300;
        }

        .content {
          margin-top: 3rem;
          font-size: 1.8rem;
          line-height: 1.8;
        }
      }
    }
  }

  .imgTextCarousel {
    .top {
      padding: 5rem 0;
      text-align: center;

      .title {
        color: #2e7de8;
        font-size: 4.6rem;
      }

      .subtitle {
        font-size: 3rem;
        color: #c0c0c0;
        padding: 1rem 0 1.5rem 0;
      }

      .line {
        margin: 0 auto;
        width: 8rem;
        background-color: #2e7de8;
        height: 0.4rem;
      }
    }
    .imgBoxList1{display: none}
    .imgBoxList {
      width: 510rem;
      height: 47rem;
      margin-left: -5rem;
      display: flex;
      overflow-x: hidden;
      position: relative;

      .box1 {
        position: absolute;
        width: 455rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        transition: 1.5s;

        .imgBox {
          width: 47rem;
          height: 47rem;
          padding: 0 2rem;
          position: relative;

          img {
            width: 100%;
            height: 40rem;
            border-radius: 0.5rem;
            cursor: pointer;
          }

          .card {
            position: absolute;
            left: 3.5rem;
            top: 30rem;
            background-color: #f6f6f6;
            border-radius: 0.5rem;
            width: 44rem;
            height: 13.8rem;
            z-index: 99;

            .textTop {
              padding: 3.5rem 0 1rem 4rem;
              text-align: left;
              font-size: 1.8rem;
              font-weight: 300;
            }

            .textBottom {
              padding: 0 0 0 4rem;
              font-size: 2.6rem;
              font-weight: 600;
              text-align: left;
            }

            .arrow-right {
              position: absolute;
              font-weight: 300;
              font-size: 2rem;
              right: 3rem;
              top: 6rem;
            }
          }

          .card:after,
          .card:before {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 0;
            background: #f6f6f6;
            z-index: -2;
            border-radius: 0.5rem;
            overflow: hidden;
          }

          .card:before {
            transition: 0.7s;
            background: #1989fb;
            z-index: -1;
          }

          .card:hover:after,
          .card:hover:before {
            height: 100%;
          }

          .card:hover {
            transition: 1s;
            cursor: pointer;
            color: #fff;
          }
        }
      }

      .box2 {
        position: absolute;
        width: 455rem;
        left: 455rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        transition: 1.5s;

        .imgBox {
          width: 47rem;
          height: 47rem;
          padding: 0 2rem;
          position: relative;

          img {
            width: 100%;
            height: 40rem;
            border-radius: 0.5rem;
            cursor: pointer;
          }

          .card {
            position: absolute;
            left: 3.5rem;
            top: 30rem;
            background-color: #f6f6f6;
            border-radius: 0.5rem;
            width: 44rem;
            height: 13.8rem;
            z-index: 99;

            .textTop {
              padding: 3.5rem 0 1rem 4rem;
              text-align: left;
              font-size: 1.8rem;
              font-weight: 300;
            }

            .textBottom {
              padding: 0 0 0 4rem;
              font-size: 3rem;
              font-weight: 600;
              text-align: left;
            }

            .arrow-right {
              position: absolute;
              font-weight: 300;
              font-size: 2rem;
              right: 3rem;
              top: 6rem;
            }
          }

          .card:after,
          .card:before {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 0;
            background: #f6f6f6;
            z-index: -2;
            border-radius: 0.5rem;
            overflow: hidden;
          }

          .card:before {
            transition: 0.7s;
            background: #1989fb;
            z-index: -1;
          }

          .card:hover:after,
          .card:hover:before {
            height: 100%;
          }

          .card:hover {
            transition: 1s;
            cursor: pointer;
            color: #fff;
          }
        }
      }
    }

    .btns {
      width: 100%;
      height: 5rem;
      line-height: 5rem;

      ul {
        width: 10rem;
        height: 3rem;
        line-height: 3rem;
        margin: 0 auto;
        padding: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;

        li {
          list-style-type: none;
          margin: 0;
          padding: 0;
          width: 1.4rem;
          height: 1.4rem;
          border-radius: 0.7rem;
          background-color: #ccc;
          cursor: pointer;
        }

        .activeBtn {
          transition: 0.5s;
          width: 1.7rem;
          height: 1.7rem;
          border-radius: 0.85rem;
          background-color: #3d8bed;
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {

  .mainPage {
  margin: 0;
  padding: 0;

  .carousel {
    .text {
      display: none;

    }
  }

  .tabs {
    width: 192rem;
    height: 60rem;

    .container {
      width: 128rem;
      margin: 0 auto;

      .tabLeft {
        float: left;
        width: 70rem;
        padding-top: 8rem;

        .tabItem {
          .titleItem {
            font-size: 2.4rem;
            text-align: left;
            margin-top: 3rem;
          }

          .content {
            font-size: 1.4rem;
            text-align: left;
            margin-top: 1rem;
          }
        }
      }

      .tabRight {
        display: inline-block;
        width: 58rem;
        padding-top: 5rem;

      }
    }
  }

  .product {
    width: 100%;

    .proTop {
      width: 100%;

      .title {
        color: #2e7de8;
        font-size: 10.6rem;
      }
    }

    .proBottom {
      width: 75%;

    }
  }

  .banner2 {
    position: relative;
    width: 100%;
    /*height: 185px;*/

    img {
      width: 100%;
      height: 120px;
    }

    .nums {
      padding: 5rem 30px  ;
      .numItem {
        width: 34rem;
        text-align: center;
        padding: 5rem 10rem;

        .content {
          margin-top: 6rem;
          line-height: 1.3;
        }
      }
    }
  }

  .imgTextCarousel {
    .top {
      padding: 5rem 0;
      text-align: center;

      .title {
        color: #2e7de8;
        font-size: 9.6rem;
      }
    }

    .imgBoxList, .btns{display: none;}
    .imgBoxList1{display: block;}
    .imgBoxList1 {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        .imgBox {
            width: 46%;
            overflow: hidden;
            img {
                width: 100%;
                height: 80rem;
                //cursor:pointer
            }
          .card {
              height: 30rem;
              line-height: 20rem;
              .textTop{ font-size: 8rem; text-align: center}
              .textBottom{display: none}
              .arrow-right{display: none}
          }
        }


    }
    .book{
      .line1{
        display: none;
      }
      .line2{
        display: none;
      }
    }


  }
}
}
</style>
<style lang="scss">
.mainPage {
  .el-carousel__item img {
    width: 100%;
    height: 100%;
  }

  .el-carousel--horizontal {
    overflow-x: hidden;
    width: 100%;
  }

  .el-carousel__container {
    height: 82rem;
  }

  .el-tabs__nav-wrap::after {
    background-color: #fff;
  }

    .abt-video {
        width: 85%;
        margin: 0 auto;
        display: block;
        background: #0B0B0B;
    }
    .abt-video video {
        width: 100%;
        height: 100%;
    }

    .abt-conjs {
        display: block;
        overflow: hidden;
        margin-top: -1.5rem;
    }
    .abt-conjs p{
        font-size: 17px;
        line-height: 26px;
        color: #5B5B5B;
        text-align: justify;
    }
}

@media screen and (max-width: 750px) {
    .abt-conjs {
        padding: 0 10rem;
        height: 110rem;
        overflow: hidden;
    }
    .abt-conjs p{
        font-size: 16rem;
        line-height: 25rem;
        color: #5B5B5B;
        text-align: justify;
    }
    .proBottom{
        width: 85% !important;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        .proItem{
            text-align: center !important;
            width: 46% !important;
            border: 1px #ddd solid;
            margin-bottom: 8rem;
            padding:9rem 0;
            img{width:18rem !important; height: 18rem !important;}
            .name{font-size: 8rem !important;}
            .link{line-height: 12rem; font-size: 7rem !important;}
        }
    }

    .numItem {
        width: 100% !important;
        .title {
            font-size: 13rem !important;
            font-weight: 300;
        }
        .subtitle {
            font-size: 8rem !important;
            font-weight: 300;
        }
        .content {
            display: none;
        }
    }
    .textBottom{display: none !important;}
}
</style>
